export default __webpack_public_path__ + "static/media/631468ed8736f759a6376634c205b72a.png";